// extracted by mini-css-extract-plugin
export default {"table_header":"vendor-vip-list_table_header__0ZgCQ","table_td":"vendor-vip-list_table_td__U+JT0"};